"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteSection = exports.updateSection = exports.addSection = exports.fetchSectionsIfNeeded = exports.DELETE_SECTION = exports.UPDATE_SECTION = exports.ADD_SECTION = exports.FETCH_SECTIONS = void 0;
var utils_1 = require("../../utils");
exports.FETCH_SECTIONS = (0, utils_1.networkActionTypes)("FETCH_SECTIONS");
exports.ADD_SECTION = (0, utils_1.networkActionTypes)("ADD_SECTION");
exports.UPDATE_SECTION = (0, utils_1.networkActionTypes)("UPDATE_SECTION");
exports.DELETE_SECTION = (0, utils_1.networkActionTypes)("DELETE_SECTION");
var fetchSections = (0, utils_1.networkAction)(exports.FETCH_SECTIONS, "/sections");
exports.fetchSectionsIfNeeded = (0, utils_1.makeIfNeededAction)(fetchSections, "sections");
var _check = function (state) { return !(state.sections.isFetching ||
    state.sections.isAdding ||
    state.sections.isUpdating ||
    state.sections.isDeleting); };
var addSection = function (sectionID, sectionData, accessToken) {
    return function (dispatch, getState) {
        var state = getState();
        if (!_check(state))
            return;
        return dispatch((0, utils_1.networkAction)(exports.ADD_SECTION, "/sections/".concat(sectionID), "PUT")(sectionData, {}, accessToken));
    };
};
exports.addSection = addSection;
var updateSection = function (sectionID, sectionData, accessToken) {
    return function (dispatch, getState) {
        var state = getState();
        if (!_check(state))
            return;
        return dispatch((0, utils_1.networkAction)(exports.UPDATE_SECTION, "/sections/".concat(sectionID), "PUT")(sectionData, {}, accessToken));
    };
};
exports.updateSection = updateSection;
var deleteSection = function (sectionID, accessToken) {
    return function (dispatch, getState) {
        var state = getState();
        if (!_check(state))
            return;
        return dispatch((0, utils_1.networkAction)(exports.DELETE_SECTION, "/sections/".concat(sectionID), "DELETE")({}, { id: sectionID }, accessToken));
    };
};
exports.deleteSection = deleteSection;
